import { inject } from '@angular/core';
import { Router, CanActivateFn, ActivatedRouteSnapshot } from '@angular/router';
import { AuthenticationService } from '../services/authentication.service';
import { toObservable } from '@angular/core/rxjs-interop';
import { filter, map, of, switchMap, take } from 'rxjs';

export const authGuard: CanActivateFn = (route: ActivatedRouteSnapshot) => {
  const authService = inject(AuthenticationService);
  const router = inject(Router);
  const hasCode = route.queryParamMap.has('code');

  if (hasCode) {
    return true;
  }

  return toObservable(authService.authInitialized).pipe(
    filter(initialized => initialized),
    take(1),
    map(() => {
      const user = authService.authenticatedUser();
      if (user) {
        if (user.onboarded) {
          return true;
        } else {
          router.navigate(['/onboarding']).finally();
          return false;
        }
      }
      router.navigate(['/login']).finally();
      return false;
    })
  );
};
